<div class="modal-wrapper" fxLayout="column" fxLayoutAlign="start stretch">
    <div class="modal-content">

        <h2 class="titulo">Confirmação</h2>

        <div class="info">

            <div><strong>Data:</strong> {{ data.schedule?.date | date: "dd/MM/yyyy" }}</div>
            <div><strong>Hora:</strong> {{ data.schedule?.hour }}</div>
            <div><strong>Profissional:</strong> {{ data.schedule?.performerName }}</div>
            <div><strong>Unidade:</strong> {{ data.companyName }}</div>

        </div>

        <h2 class="titulo">Selecione o procedimento</h2>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Procedimento</mat-label>
            <input type="text" placeholder="Digite para buscar..." aria-label="Procedimento" matInput
                [formControl]="procedureControl" [matAutocomplete]="auto3" />
            <mat-icon matSuffix>search</mat-icon>
            <mat-autocomplete #auto3="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let procedure of procedureList" [value]="procedure">
                    {{ procedure.name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <div class="actions">
            <button mat-raised-button color="primary" type="button" (click)="confirm()"
                [disabled]="!procedureControl.value?.id">
                <mat-icon>check_circle</mat-icon>
                <span>Confirmar Agendamento</span>
            </button>
        </div>

    </div>
</div>
